module.exports = __webpack_public_path__ + "img/arrow-up.7a329f55.svg";